import { ManagementGrid } from '@/routes/admin/components/ManagementGrid/ManagementGrid'
import React from 'react'

export interface ArgomentoProblemaGridProps {
  selectedApp?: number
  selectedPlatform?: number
}

export const ArgomentoProblemaGrid: React.FC<ArgomentoProblemaGridProps> = (props) => {
  const filterCondition = (() => {
    if (props.selectedApp) {
      return ['qs_applicazione.id', '=', props.selectedApp]
    } else if (props.selectedPlatform) {
      return ['piattaforma.id', '=', props.selectedPlatform]
    } else {
      return undefined
    }
  })()

  return (
    <>
      <ManagementGrid
        initialFilter={filterCondition}
        endpoint={`${import.meta.env.VITE_QSADMINAPI_HOST}/argomento_problema`}
        columns={[
          {
            dataField: 'id',
            caption: 'ID',
            dataType: 'number',
            allowEditing: false,
          },
          {
            dataField: 'nome',
            caption: 'Nome',
            dataType: 'string',
            allowEditing: true,
          },
          {
            dataField: 'note',
            caption: 'Note',
            dataType: 'string',
            allowEditing: true,
          },
          // {
          //   dataField: 'piattaforma.id',
          //   caption: 'Piattaforma',
          //   dataType: 'string',
          //   allowEditing: true,
          // },
          // {
          //   dataField: 'qs_applicazione.id',
          //   caption: 'Applicazione Supporto QS',
          //   dataType: 'string',
          //   allowEditing: true,
          // },
        ]}
        expandRelations={['piattaforma', 'qs_applicazione']}
        keyField={'id'}
        storageKey={`argomento-problema-state-management-grid`}
        defaultPageSize={20}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
        onInitNewRowOverride={(e) => {
          e.data.piattaforma = props.selectedPlatform ? { id: props.selectedPlatform } : undefined
          e.data.qs_applicazione = props.selectedApp ? { id: props.selectedApp } : undefined
        }}
      />
    </>
  )
}
